import React from "react";

const BackgroundCircles: React.FC = () => {
  return (
    <svg
      viewBox="0 0 1224 297"
      className="absolute top-0 right-0 w-full h-auto pointer-events-none opacity-70"
    >
      <circle fill="#7EBEA5" cx="779.54" cy="50.58" r="4.79" />
      <circle fill="#7365FF" cx="721.50" cy="12.77" r="6.38" />
      <circle fill="#26295E" fillOpacity="0.6" cx="1127.22" cy="61.76" r="6.38" />
      <circle fill="#7B9DED" cx="841.30" cy="7.98" r="3.72" />
      <circle fill="#7365FF" cx="947.79" cy="36.73" r="3.72" />
      <circle fill="#7B9DED" fillOpacity="0.6" cx="46.32" cy="44.08" r="3.72" />
      <circle fill="#7B9DED" fillOpacity="0.6" cx="3.72" cy="233.63" r="3.72" />
      <circle fill="#7365FF" fillOpacity="0.6" cx="1152.25" cy="114.47" r="3.72" />
      <circle fill="#7365FF" fillOpacity="0.4" cx="1074.51" cy="3.72" r="3.72" />
      <circle fill="#7365FF" fillOpacity="0.4" cx="1209.75" cy="22.89" r="3.72" />
      <circle fill="#7EBEA5" fillOpacity="0.4" cx="964.30" cy="2.12" r="2.12" />
      <circle fill="#7B9DED" fillOpacity="0.4" cx="1015.41" cy="68.15" r="2.12" />
      <circle fill="#7B9DED" cx="772.62" cy="238.53" r="2.12" />
      <circle fill="#26295E" fillOpacity="0.6" cx="45.79" cy="294.87" r="2.12" />
      <circle fill="#7EBEA5" fillOpacity="0.4" cx="1064.40" cy="133.11" r="2.12" />
      <circle fill="#7365FF" fillOpacity="0.4" cx="1013.51" cy="109.19" r="2.12" />
      <circle fill="#7365FF" cx="1218.27" cy="92.11" r="4.79" />
      <circle fill="#7EBEA5" cx="31.41" cy="137.79" r="5.85" />
    </svg>
  );
};

export default BackgroundCircles;
